import Vue from 'vue'

export default function cancelOut({ book_outs }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/bookouts/cancel"
    return Vue.http
        .post(url, { book_outs }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response).catch((e) => { throw e })
}